import { render } from "./Package-index.vue?vue&type=template&id=2972bb74&scoped=true"
import script from "./Package-index.vue?vue&type=script&lang=js"
export * from "./Package-index.vue?vue&type=script&lang=js"

import "./Package-index.vue?vue&type=style&index=0&id=2972bb74&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2972bb74"]])

export default __exports__